import React, {ReactNode} from 'react';
import {useProjectData} from "../../hooks/useProjectData";
import {Alert} from "@mui/material";
import ContentArea from "./ContentArea";

interface ProjectLayoutContainerProps {
    children: ReactNode
}

function ProjectLayoutContainer({children}: ProjectLayoutContainerProps) {
    const {id, error} = useProjectData()

    return (
        <ContentArea key={id}>
            {error ?
                <Alert severity="error">Project could not be loaded ({error.resolveUserMessage()}). Please refresh,
                    try again soon, or log out and log back in.</Alert>
                : children}
        </ContentArea>
    );
}

export default ProjectLayoutContainer;
